export default {
  API_ENDPOINT: 'https://intense-fjord-29844.herokuapp.com',
  // API_ENDPOINT: 'http://localhost:8000/api',
  TOKEN_KEY: 'blest-client-auth-token'
};
